import React from 'react';
import { func, object } from 'prop-types';
import styled from 'styled-components';
import Icon from '~/modules/components/global/icon';

const Tag = styled.button`
	box-sizing: border-box;
	display: inline-block;
	margin: 0 0.375rem 0.25rem 0;
	border: 0;
	border-radius: 0.125rem;
	background: ${({ theme }) => theme['blue-darken-15']};
	padding: 0.375rem 0.5rem;
	line-height: inherit;
	color: ${({ theme }) => theme['white']};
	font-size: inherit;
	font-weight: 700;

	&::after {
		opacity: 0.75;
		margin-left: 0.5rem;
		color: ${({ theme }) => theme['white']};
		content: '\\2715';
	}

	&:hover,
	&:focus {
		outline: 0;
		background: ${({ theme }) => theme['blue-darken-20']};
	}

	svg {
		position: relative;
		top: -0.0625rem;
		margin-right: 0.5rem;
		width: 0.75rem;
		height: 0.75rem;

		path {
			fill: ${({ theme }) => theme['white']};
		}
	}
`;

function IconTag(props) {
	const {
		tag,
		classNames,
		onDelete
	} = props;

	let displayName = tag.label || tag.value.name || tag.value.emailNormal;

	return (

		<span data-tooltip="Click to remove">
			<Tag
				type="button"
				onClick={() => onDelete(tag.value)}
				data-cy="contact-picker-tag"
				className="px-contact-picker-tag"
			>
				<Icon use={tag.icon} />
				<span className={classNames.selectedTagName}>
					{displayName}
				</span>
			</Tag>
		</span>
	);
}

IconTag.propTypes = {
	onDelete: func.isRequired,
	tag: object.isRequired,
	classNames: object.isRequired
};

export default IconTag;
